import React from "react";
import CircleIcon from "@mui/icons-material/FiberManualRecord";

const DeviceStateStatusIcon = ({ status }) => {
    let colorClass = "color-yellow"; // default

    if (status === 1) {
        colorClass = "color-green";
    } else if (status === -1) {
        colorClass = "color-red";
    } else if (status === 0) {
        colorClass = "color-grey";
    } else if (status === 2) {
        colorClass = "color-yellow";
    }

    return <CircleIcon className={`pad-5 ${colorClass}`} />;
};

export default DeviceStateStatusIcon;